import $ from 'jquery';
import { getScrollTop, getWidth, getHeight, onScroll } from '../utils/window';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');
	const headerHeight = $header.outerHeight();
	const $headerButtonNormal = $header.find('.header_button.-type-normal');
	var overlay = false;


	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				// $scroller.animate({ scrollTop: 0 }, { duration: 200 });
				$headerNav.find('.-parent').removeClass('is-open');
				$headerNav.find('.-parent > ul').css('display', '');
			}
		});
	}

	function closeMenuItems() {
		$headerNav.find('.-parent').each(function(){
			const _this = this;
			
			$(_this).find('> ul').slideUp('fast', function(){
				$(_this).removeClass('is-open');
			});
		});
	}

	$headerNav.find('.-parent').each(function(){
		const _this = this;
		$(_this).find('> a').click(function(e){
			e.preventDefault();
			// $headerNav.find('.-parent').removeClass('is-open');
			
			
			// closeMenuItems();
			// $(_this).addClass('is-open');
			// $(_this).find('> ul').slideDown('fast');
			

			if(!$(_this).hasClass('is-open')) {
				closeMenuItems();
				$(_this).addClass('is-open');
				$(_this).find('> ul').slideDown('fast');
			} else {
				$(_this).find('> ul').slideUp('fast', function(){
					$(_this).removeClass('is-open');
				});
			}
		});
	});

	if(getWidth() > 1080) {

		var lastScrollTop = 0;

		if($header.hasClass('-overlay')) {
			overlay = true;
			$header.addClass('is-stuck');
		}

		onScroll(function (){

			// if(getScrollTop() > headerHeight && $header.hasClass('-overlay')) {
			// 	if(!$header.hasClass('is-sticky')) {
			// 		$header.addClass('is-sticky');
			// 		$header.attr('style', 'transition: none;');

			// 		setTimeout(function(){
			// 			$header.attr('style', '');
			// 		}, 300);
			// 	}
			// } else {
			// 	$header.removeClass('show-fixed');
			// 	$header.removeClass('hide-fixed');
			// 	$header.removeClass('is-sticky');
			// }

			// when scrolling
			let st = getScrollTop();
			if (st > lastScrollTop){
				// downscroll code
				if(getScrollTop() > headerHeight) {
					$header.removeClass('show-fixed');
					$header.addClass('hide-fixed');
	
					if(overlay) {
						setTimeout(function(){
							$header.removeClass('-overlay');
							$headerButtonNormal.addClass('-no-overlay');
						}, 300);				
					}
				} else {
					$header.removeClass('show-fixed');
					$header.removeClass('hide-fixed');
				}

			} else {
				// upscroll code
				$header.removeClass('hide-fixed');
				$header.addClass('show-fixed');

				if(getScrollTop() < headerHeight && overlay) {
					$header.addClass('-overlay');
					$headerButtonNormal.removeClass('-no-overlay');		
				}
			}
			lastScrollTop = st;


		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js